import store from '../store/index';

let configArr = [
  {
    href: 'localhost',
    title: '田东县农村产权交易系统与普惠金融服务平台',
    citytitle: '广西田东',
    tId: 'bc3192ec4dbf466eb0e90caa2a036781',
    skinStyleCode: '',
    areaCode: '451022',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'gxcqjyzx',
    title: '田东县农村产权交易系统与普惠金融服务平台',
    citytitle: '广西田东',
    tId: 'bc3192ec4dbf466eb0e90caa2a036781',
    skinStyleCode: '',
    areaCode: '45',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  },
  {
    href: 'tiandong',
    title: '田东县农村产权交易系统与普惠金融服务平台',
    citytitle: '广西田东',
    tId: 'bc3192ec4dbf466eb0e90caa2a036781',
    skinStyleCode: '',
    areaCode: '451022',
    temAreaCode: '',
    areaLevel: 1,
    startLevel: '1',
    showLevel: '5',
    showLevelList: [false, false, false, false, false, false],
    loginLogo: ''
  }
];

export function getComParams () {
  let localHost = window.location.host;
  const tenantParams = configArr.find(item => localHost.includes(item.href));
  store.commit('SET_TENANT_PARAMS', tenantParams || {}); // 存储租户id

  // 设置网页标题
  let href = window.location.origin;
  let env = '';
  if (href.indexOf('dev') >= 0 || href.indexOf('http://localhost') >= 0) {
    env = '(开发)';
  } else if (href.indexOf('test') >= 0) {
    env = '(测试)';
  } else if (href.indexOf('jlncjy.cn') >= 0 || href.indexOf('stage') >= 0) {
    env = '(准生产)';
  }
  document.title = env + tenantParams.title;
}

export function getComParamsTitle () {
  let localHost = window.location.host;
  const tenantParams = configArr.find(item => localHost.includes(item.href));
  return tenantParams.citytitle;
}
